var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Body } from 'syf-component-library/ui/typography';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import { colors } from 'syf-component-library/defaultTheme';
import { DateSection, DetailsContainer, DueDateContainer, IconSection, TitleContainer } from './subcomponents';
import { translate } from '../../../strings/i18n';
import { FAR_CALENDAR_DAY } from '../../../../../const/icon-props';
import Icon from '../../icon';
import addOrdinalSuffix from '../../../helpers/add-ordinal-suffix';
var Details = function (_a) {
    var currentDueDay = _a.currentDueDay, selectedDay = _a.selectedDay;
    return (_jsxs(DetailsContainer, __assign({ top: "xlarge", bottom: "small" }, { children: [_jsx(TitleContainer, { children: translate('successfulScreen.details') }), _jsxs(Inset, __assign({ top: "medium", bottom: "xlarge" }, { children: [_jsxs(DueDateContainer, { children: [_jsxs(IconSection, { children: [_jsx(Inset, __assign({ horizontal: "xsmall", vertical: "small" }, { children: _jsx(Icon, { title: "check circle icon", icon: FAR_CALENDAR_DAY, size: "lg", color: colors.cyanBlue }) })), _jsx(Body, { children: translate('successfulScreen.newPaymentDueDate') })] }), _jsx(DateSection, { children: translate('successfulScreen.newDate', {
                                    date: addOrdinalSuffix(selectedDay)
                                }) })] }), _jsx(Stack, { size: "medium" }), _jsxs(DueDateContainer, { children: [_jsxs(IconSection, { children: [_jsx(Inset, __assign({ horizontal: "xsmall", vertical: "small" }, { children: _jsx(Icon, { title: "check circle icon", icon: FAR_CALENDAR_DAY, size: "lg", color: colors.cyanBlue }) })), _jsx(Body, { children: translate('successfulScreen.currentPaymentDueDate') })] }), _jsx(DateSection, { children: translate('successfulScreen.currentDate', {
                                    date: addOrdinalSuffix(currentDueDay)
                                }) })] })] }))] })));
};
export default Details;
